import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPaginationInfo } from '../../store/entities/selectors';
import { makeStyles } from '@material-ui/core/styles';
import { getAudioList } from '../../store/system/actions';
import clsx from 'clsx';
import { deviceMaxWidth } from '../../constants';

export default function PlaylistPagination() {
  const styles = useStyles();
  const { next, previous, count } = useSelector(selectPaginationInfo);
  const dispatch = useDispatch();

  const searchNextParams = next
    ? new URLSearchParams(next.split('?')?.[1])
    : null;
  const searchPreviousParams = previous
    ? new URLSearchParams(previous.split('?')?.[1])
    : null;

  const previousParams =
    searchPreviousParams && Object.fromEntries(searchPreviousParams.entries());
  const nextParams =
    searchNextParams && Object.fromEntries(searchNextParams.entries());

  // @ts-ignore
  const currentPage = previous
    ? Number(previousParams?.page) + 1 || 2
    : Number(nextParams?.page) - 1 || '';

  const prevPage = () =>
    previous ? dispatch(getAudioList(previousParams)) : () => {};
  const nextPage = () => (next ? dispatch(getAudioList(nextParams)) : () => {});

  return (
    <div className={styles.buttonContainer}>
      <div className={styles.numbers}>{`${currentPage} из ${count}`}</div>
      <div className={styles.controls}>
        <div
          className={clsx(styles.button, !previous && styles.disabled)}
          onClick={prevPage}
        >
          Предыдущая
        </div>
        <div
          className={clsx(styles.button, styles.next, !next && styles.disabled)}
          onClick={nextPage}
        >
          Следующая
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    [deviceMaxWidth.size768]: {
      flexDirection: 'column',
    },
  },
  numbers: {
    marginLeft: 2,
    width: '50%',
    fontSize: 16,
    color: '#603004',
    marginBottom: 0,
    [deviceMaxWidth.size768]: {
      marginBottom: 5,
    },
  },
  button: {
    height: 30,
    backgroundColor: '#FEC795',
    color: '#603004',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    cursor: 'pointer',
    padding: '0 15px',
  },
  disabled: {
    color: '#919191',
    backgroundColor: '#E6E7ECB7',
    cursor: 'not-allowed',
  },
  next: {
    marginLeft: 10,
  },
  controls: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
